<template>
    <div class="translation-wrapper">
        <el-dropdown placement="top-start" trigger="hover" ref="qMsgDropdown">
            <span class="el-dropdown-link">
                <img class="item_img w-24 h-24" v-if="isTranslating" src="@/assets/loading.gif" alt=""
                    style="opacity: 0.7;">
                <img class="item_img w-24 h-24" v-else-if="isTranslated && !userModified" src="@/assets/icon/yFy.png"
                    alt="" @click="lmyFir()">
                <img class="item_img w-24 h-24" v-else src="@/assets/icon/nFy.png" alt="" @click="lmyFir()">
            </span>
            <el-dropdown-menu slot="dropdown" class="stickersClass" style="width: 60vw;">
                <div class="BBox">
                    <div class="title mb-10">翻译引擎</div>
                    <div class="provider-tabs">
                        <div class="commonBox pointer" v-for="item in translationProviders" :key="item.id"
                            @click="handleProviderClick(item.id)"
                            :class="{ active: translationProvider === item.id, disabled: isTranslating }">
                            {{ item.name }}
                        </div>
                    </div>
                    <div class="title mb-10 mt-4">
                        推荐
                        <template v-if="currentLanguage">(当前目标语言：{{ currentLanguage }})</template>
                    </div>
                    <div>
                        <div style="display: flex; flex-wrap: wrap;align-items: center;">
                            <div class="commonBox pointer" v-for="(v, i) in firstTenItems" :key="i"
                                @click="!isTranslating && lmyFir(v)" :class="{ 'disabled': isTranslating }">
                                {{ v.name }}
                            </div>
                        </div>
                    </div>
                    <div class="title mb-10 mt-4">
                        其他
                    </div>
                    <div>
                        <div style="display: flex; flex-wrap: wrap;align-items: center;">
                            <div class="commonBox pointer" v-for="(v, i) in fromTenthToEnd" :key="i"
                                @click="!isTranslating && lmyFir(v)" :class="{ 'disabled': isTranslating }">
                                {{ v.name }}
                            </div>
                        </div>
                    </div>
                </div>
            </el-dropdown-menu>
        </el-dropdown>
        <span class="current-language-display">
            {{ currentProviderLabel }} · {{ currentLanguage || '未设置' }}
        </span>
    </div>
</template>

<script>
import language from '../utils/language'
import { translate } from '@/api/youdaoSign';
import {
    TRANSLATION_PROVIDERS,
    getTranslationSettings,
    setTranslationSettings,
} from '@/utils/translationSettings';

export default {
    props: {
        message: {
            type: String,
            default: ''
        },
    },
    computed: {
        firstTenItems() {
            return this.languageData?.languageList.slice(0, 20);
        },
        fromTenthToEnd() {
            return this.languageData?.languageList.slice(19);
        },
        currentProviderLabel() {
            const provider = this.translationProviders.find(item => item.id === this.translationProvider);
            return provider ? provider.name : '';
        },
        translationProviders() {
            return TRANSLATION_PROVIDERS;
        },
    },
    data() {
        const settings = getTranslationSettings();
        return {
            isTranslated: false,
            languageData: language,
            translatedBefore: '',
            currentLanguage: '',
            isTranslating: false,
            userModified: false,
            lastTranslation: '',
            translationProvider: settings.provider,
        }
    },
    created() {
        if (localStorage.getItem('language')) {
            const list = this.languageData?.languageList;
            const foundItem = list.find(item => item.code.includes(localStorage.getItem('language')));
            if (foundItem) {
                this.currentLanguage = foundItem.name;
            }
        }
    },
    watch: {
        message: {
            handler(newVal) {
                if (this.isTranslated && this.lastTranslation && newVal !== this.lastTranslation) {
                    this.userModified = true;
                    this.isTranslated = false;
                }
            },
            immediate: false
        }
    },
    methods: {
        handleProviderClick(providerId) {
            if (this.isTranslating) return;
            const settings = setTranslationSettings({ provider: providerId });
            this.translationProvider = settings.provider;
        },
        lmyFir(v) {
            if (!this.message) {
                if (v) {
                    localStorage.setItem('language', v.code)
                    this.$message.success('目标翻译语言设置成功')
                    this.currentLanguage = v.name
                    return
                } else {
                    this.$message.error('请输入内容')
                    return
                }
            }

            if (v) {
                localStorage.setItem('language', v.code)
                this.currentLanguage = v.name
                this.handleTranslate(this.message, v.code)
            } else {
                if (this.isTranslated && !this.userModified) {
                    this.isTranslated = false
                    this.userModified = false
                    this.$emit('checkQMsg', this.translatedBefore)
                } else {
                    const targetLang = localStorage.getItem('language') || 'zh-CHS'
                    this.handleTranslate(this.message, targetLang)
                }
            }
        },
        async handleTranslate(v, toTra) {
            const toLang = toTra || 'zh';
            this.isTranslating = true

            try {
                let translation = await translate(v, 'auto', toLang)
                if (translation && toLang === 'en') {
                    translation = translation.charAt(0).toUpperCase()
                        + translation.slice(1).toLowerCase();
                }
                this.$emit('checkQMsg', translation)
                this.isTranslated = true
                this.translatedBefore = v
                this.lastTranslation = translation
                this.userModified = false
            } catch (err) {
                this.$message.error(err.message || '翻译失败，请稍后重试')
            } finally {
                this.isTranslating = false
            }
        },
    },
}
</script>

<style scoped lang='scss'>
.translation-wrapper {
    display: flex;
    align-items: center;
    gap: 8px;
}

.current-language-display {
    font-size: 12px;
    color: #666;
    background: #f5f5f5;
    padding: 2px 8px;
    border-radius: 12px;
    white-space: nowrap;
    border: 1px solid #e0e0e0;
    min-width: 40px;
    text-align: center;
    font-weight: 500;
}

.BBox {
    padding: 10px;

    .title {
        font-weight: 600;
    }

    .provider-tabs {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
    }

    .commonBox {
        margin: 0 5px 5px 0;
        padding: 5px 10px;
        border: 1px solid transparent;
        border-radius: 4px;

        &.active {
            color: #409eff;
            border-color: #409eff;
            background: #ecf5ff;
        }

        &.disabled {
            opacity: 0.5;
            cursor: not-allowed;
            pointer-events: none;
        }
    }
}
</style>
